export default __webpack_public_path__ + "static/media/black-configure-data-symbols-icon.668baf68.svg";